<!--
  -  Copyright (c) Qwoach LLC 2023. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 24/10/2023
  -->

<template>
	<infinite-loading
		ref="infiniteLoader"
		v-bind="attrsComputed">
		<template #spinner><div></div></template>
		<template #no-more><div></div></template>
		<template #no-results><div></div></template>
	</infinite-loading>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import InfiniteLoading from 'vue-infinite-loading';

// there is a problem where when there are multiple vue-infinite-loading components on the screen,
// calling complete on one detaches listeners on all components.
// this is a workaround for that problem
// https://github.com/PeachScript/vue-infinite-loading/issues/327

export default {
	name: "InfiniteLoadingFixed",
	extends: BaseComponent,
	components: {InfiniteLoading},

	inheritAttrs: false,

	data() {
		return {
			isFixed: false
		}
	},

	methods: {
		attemptLoad() {
			return this.$refs.infiniteLoader.attemptLoad()
		},

	},
	computed: {
		attrsComputed() {
			let {onInfinite, ...rest} = this.$attrs

			return {
				...rest,
				onInfinite: (state) => {
					if(state && !this.isFixed){
						this.isFixed = true
						state.complete = completeFixed.bind(this.$refs.infiniteLoader)
					}
					if(onInfinite){
						onInfinite(state)
					}
				}
			}
		}
	},

}

function completeFixed(state) {
	if(!state){
		return
	}
	console.log("completeFixed: ", state)
	state.complete = () => {
		this.status = 2 //STATUS.COMPLETE

		this.$nextTick(() => {
			this.$forceUpdate();
		});
	}
}

</script>

<style lang="scss">

</style>
